<div class="account-pages"></div>
<div class="clearfix"></div>
<div class="wrapper-page">
	<div class="card-box">
		<div class="panel-heading text-center">
			<img src="/style/logo/1" alt="" style="width: 100%;"></img>
			{{#if message}}
				<div class="alert alert-info m-t-20">
					<strong>{{{message.summary}}}</strong>
				</div>
			{{/if}}
			{{#if errors.error}}
				<div id="ct-unknown-user" class="alert alert-danger m-t-20">{{errors.error}}</div>
			{{/if}}
			{{#if info}}
				<div class="alert alert-info m-t-20">{{info}}</div>
			{{/if}}
		</div>
		<div class="panel-body">
			<form class="form-horizontal" action="#" method="post">
				{{#if openIDProvider}}
				{{#each openIDProvider}}
				<a href="{{link}}" class="form-control btn btn-white btn-block">
					<i class="fa fa-{{type}}"></i>&nbsp;{{name}}
				</a>
				{{/each}}
				<hr />
				{{/if}}
				<div class="form-group">
					<div class="col-xs-12">
						<input id="js-email-input" class="form-control {{#if errors.email}}parsley-error{{/if}}" type="email" name="username" placeholder="{{TR "E-Mail"}}" value="{{formData.username}}" autofocus>
						{{#if errors.email}}
						<ul class="parsley-errors-list filled" id="js-email-error">
							<li class="parsley-required">{{TR "E-Mail ist"}} {{errors.email}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group">
					<div class="col-xs-12">
						<input id="js-password-input" class="form-control {{#if errors.password}}parsley-error{{/if}}" type="password" name="password" placeholder="{{TR "Passwort"}}" autocomplete="off">
						{{#if errors.password}}
						<ul class="parsley-errors-list filled" id="js-password-error">
							<li class="parsley-required">{{TR "Passwort ist"}} {{errors.password}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group ">
					<div class="col-xs-12">
						<div class="checkbox checkbox-primary">
							<input id="checkbox-signup" type="checkbox" name="remember_me">
							<label for="checkbox-signup">{{TR "Angemeldet bleiben"}}</label>
						</div>
					</div>
				</div>
				<div class="form-group text-center m-t-40">
					<div class="col-xs-12">
						<button id="js-login-btn" class="js-login btn btn-pink btn-block text-uppercase" type="submit">
							{{TR "Anmelden"}}
						</button>
					</div>
				</div>
				<div class="form-group m-t-30 m-b-0">
					<div class="col-xs-7">
						<a id="ct-forgot-pw" href="#password-reset">
							<i class="fa fa-lock m-r-5"></i>
							{{TR "Probleme beim Anmelden?"}}
						</a>
					</div>
					<div class="col-xs-5">
						<div class="js-lang-menu pull-right" data-toggle="popover" data-html="true" data-content="{{TR_SELECTOR}}">
							{{TR 'Sprache'}}: <strong>{{lang}}</strong> <span class="caret"></span>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 text-center">
			<p>
				{{TR "Um die Funktionsfähigkeit der Anwendung sicherzustellen verwendet diese Webseite Cookies."}}<br>
				<a href="#" id="js-gdpr">{{TR "Datenschutzhinweis"}}</a>
			</p>
		</div>
	</div>
{{!--

	TODO: Remove as soon as "real" signups should be allowed.
	      Currently, only signup by invitation is allowed.

	{{#unless isSubdomain}}
	<div class="row">
		<div class="col-sm-12 text-center">
			<p>
				{{TR "Sie haben noch keinen Account?"}}
				<a href="#signup" class="m-l-5"><b>{{TR "Registrieren"}}</b></a>
			</p>
		</div>
	</div>
	{{/unless}}
--}}
</div>

{{> PARTIAL_FOOTER}}
